import { useScaffold } from "@Light/scaffold";
import { formatBrandedPlanName } from "@Light/utils/formatting";
import type { EnrollmentTermsProps } from "@Light/utils/utility";

export const ErcotDisclosureTerms = () => (
  <>
    I have read, understand and accept the disclosures and terms of service of
    Light, PUCT #10340.
  </>
);

export const ErcotAuthorizationTerms = ({ plan }: EnrollmentTermsProps) => {
  const scaffold = useScaffold();
  return (
    <>
      By selecting ‘Complete enrollment,’ I designate Light to perform necessary
      tasks to initiate my service with the{" "}
      {formatBrandedPlanName(scaffold.page, plan.name)}.
    </>
  );
};
